import Icon from '../components/Icon.vue'

Icon.register({"rupee-sign":{"width":320,"height":512,"paths":[{"d":"M308 96C314.6 96 320 90.6 320 84V44C320 37.4 314.6 32 308 32H12C5.4 32 0 37.4 0 44V88.7C0 95.4 5.4 100.7 12 100.7H97.3C124.6 100.7 145.5 110.7 158.3 128H12C5.4 128 0 133.4 0 140V180C0 186.6 5.4 192 12 192H170.8C164.5 228.1 137.8 250.6 96 250.6H12C5.4 250.6 0 256 0 262.6V315.6C0 319 1.4 322.2 3.9 324.5L168.9 476.8A12-12 0 0 1 177.1 480H259.6C270.5 480 275.8 466.6 267.8 459.2L116.9 319.9C193.4 317.6 248 266.5 255.2 192H308C314.6 192 320 186.6 320 180V140C320 133.4 314.6 128 308 128H249.3C245.8 116.5 241 105.8 235.1 96H308z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rupee-sign.js
// module id = gwDu
// module chunks = 0